import React, { Component } from 'react';
import Lottie from 'react-lottie';
import rolloverPlaces from '../assets/animations/Rollover_Places.json';
import rolloverSites from '../assets/animations/Rollover_Sites.json';

class Hall360Cursor extends Component {
  render() {
    if( this.props.overMarker ) {

      let animation = ( this.props.overMarker < 9 ? rolloverPlaces : rolloverSites );

      const defaultOptions = {
        loop: false,
        autoplay: true,
        animationData: animation,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
        }
      };

      return (
        <div
          className="Hall360Cursor"
          style={{ 'top': this.props.mousePos[ 1 ], 'left': this.props.mousePos[ 0 ] }}>
          <Lottie options={defaultOptions}
            height={100}
            width={100}/>
        </div>
      )
    } else {
      return null;
    }
  }
}

export default Hall360Cursor;